import { CURSIVE, SANS_SERIF, SERIF } from '../../constants/embroidery'

export const typeFaceTwObjs = [SANS_SERIF, CURSIVE, SERIF]

export const typeFaceTwAllObjs = typeFaceTwObjs

export const positionTwObjs = [
  { label: '大拇指', value: 'thumbFinger' },
  { label: '小指', value: 'childFinger' },
  { label: '手背四指', value: 'pinkyFingerSideBack' },
  { label: '内裡(第一行)', value: 'leatherLiningFirst' },
  { label: '内裡(第二行)', value: 'leatherLiningSecond' }
]

export const colorTwObjs = [
  { label: '黑色', value: 'black', color: '#1E1E1E' },
  { label: '白色', value: 'white', color: '#ffffff' },
  { label: '紅色', value: 'red', color: '#CB1527' },
  { label: '藍色', value: 'blue', color: '#0066CC' },
  { label: '黃色', value: 'yellow', color: '#FFD700' },
  { label: '綠色', value: 'green', color: '#008000' },
  { label: '橘色', value: 'orange', color: '#FF6C23' },
  { label: '粉紅色', value: 'pink', color: '#FF69B4' },
  { label: '金色', value: 'gold', color: '#FFD700' },
  { label: '銀色', value: 'silver', color: '#C0C0C0' },
  { label: '深藍色', value: 'navy', color: '#0d194a' },
  { label: '紫色', value: 'purple', color: '#800080' },
  { label: '棕色', value: 'brown', color: '#8B4513' },
  { label: '灰色', value: 'gray', color: '#808080' }
]

export const shadowEdgeColorTwObjs = [{ label: '無', value: 'none' }, ...colorTwObjs]

export const tw2JaEmbroideryPartsTranslates = [
  // 刺繍のフォント
  // { taiwan: '活字体', japanese: 'ゴシック体' }, --- IGNORE ---
  // { taiwan: '筆記体', japanese: '筆記体' }, --- IGNORE ---
  // { taiwan: '漢字', japanese: '明朝体' }, --- IGNORE ---

  // 刺繍の位置
  { taiwan: '大拇指', japanese: '親指部分' },
  { taiwan: '小指', japanese: '小指部分' },
  { taiwan: '手背四指', japanese: '小指側背面' },
  { taiwan: '内裡(第一行)', japanese: '裏革部分(1段目)' },
  { taiwan: '内裡(第二行)', japanese: '裏革部分(2段目)' },

  // 色
  { taiwan: '黑色', japanese: 'ブラック' },
  { taiwan: '白色', japanese: 'ホワイト' },
  { taiwan: '紅色', japanese: 'レッド' },
  { taiwan: '藍色', japanese: 'ブルー' },
  { taiwan: '黃色', japanese: 'イエロー' },
  { taiwan: '綠色', japanese: 'グリーン' },
  { taiwan: '橘色', japanese: 'オレンジ' },
  { taiwan: '粉紅色', japanese: 'ピンク' },
  { taiwan: '金色', japanese: 'ゴールド' },
  { taiwan: '銀色', japanese: 'シルバー' },
  { taiwan: '深藍色', japanese: 'ネイビー' },
  { taiwan: '紫色', japanese: 'パープル' },
  { taiwan: '棕色', japanese: 'ブラウン' },
  { taiwan: '灰色', japanese: 'グレー' },
  { taiwan: '無', japanese: 'なし' }
]
